import { Box, Divider, Drawer, List, ListItem, ListItemIcon, ListItemText, Toolbar } from '@mui/material';
import HomeIcon from '@mui/icons-material/Home';
import { Link } from 'react-router-dom';
import LinkList from './Lists/LinkList';
import PipelineList from './Lists/PipelineList';
import { Trans } from 'react-i18next';

const drawerWidth = 240;

const NavigationDrawer = (): JSX.Element => {
  return (
    <Drawer
      variant={'permanent'}
      sx={{
        width: drawerWidth,
        flexShrink: 0,
        [`& .MuiDrawer-paper`]: { width: drawerWidth, boxSizing: 'border-box' },
      }}
    >
      <Toolbar />
      <Box sx={{ overflow: 'auto' }}>
        <List>
          <ListItem button component={Link} to={'/'}>
            <ListItemIcon>
              <HomeIcon />
            </ListItemIcon>
            <ListItemText>
              <Trans>Homepage</Trans>
            </ListItemText>
          </ListItem>
        </List>
        <Divider />
        <PipelineList />
        <Divider />
        <LinkList />
      </Box>
    </Drawer>
  );
};

export default NavigationDrawer;
